import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { reportAdvancePaymentsTypes } from "redux/reducers/Reports/reportAdvancePayments/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_REPORT_ADVANCE_PAYMENTS_FILTERS } = reportAdvancePaymentsTypes;

export const getReportAdvancePaymentsAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    dispatch(startRequestComp('loadingReportAdvancePayments'));
    try {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/reports/advance-payments?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
      const res = await axios.get(url, {
        headers: { authorization: token },
        responseType: "blob"
      });

      saveAs(res.data, `Reporte_Anticipos_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportAdvancePayments'));
    }
  };
};

export const setReportAdvancePaymentsFilters = (key = "", value) => ({
  type: SET_REPORT_ADVANCE_PAYMENTS_FILTERS,
  payload: { key, value }
});
